import { Component, DestroyRef, OnInit, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { TitleService } from "@app/services/title.service";

@Component({
    selector: "app-courses-details-page",
    templateUrl: "./courses-details-page.component.html",
    styleUrls: ["./courses-details-page.component.scss"],
})
export class CoursesDetailsPageComponent implements OnInit {
    pageData = "";
    courseLink = "";
    private destroyRef = inject(DestroyRef);
    constructor(
        private route: ActivatedRoute,
        private titleService: TitleService,
    ) {}

    ngOnInit(): void {
        this.route.data
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
                switch (data.kind) {
                    case "university-kusto": {
                        this.pageData = "university-kusto";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Kusto Query Language",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/training/modules/write-first-query-kusto-query-language/";
                        break;
                    }
                    case "kusto-insights": {
                        this.pageData = "kusto-insights";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle:
                                    "Kusto Query Language -  Gain insights from your data by using",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/learn/modules/gain-insights-data-kusto-query-language/";
                        break;
                    }
                    case "azure-dataexplorer": {
                        this.pageData = "azure-dataexplorer";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Azure Data Explorer (ADX)",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/training/modules/intro-to-azure-data-explorer/";
                        break;
                    }

                    case "azure-datafactory": {
                        this.pageData = "azure-datafactory";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Azure Data Factory (ADF)",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/training/modules/intro-to-azure-data-factory/";
                        break;
                    }
                    case "azure-createdatafactory": {
                        this.pageData = "azure-createdatafactory";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle:
                                    "Azure Data Factory - Create a data factory",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/training/modules/data-integration-azure-data-factory/";
                        break;
                    }
                    case "azure-createpipeline": {
                        this.pageData = "azure-createpipeline";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle:
                                    "Azure Data Factory - Creating and Managing Data Pipelines",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/training/paths/data-integration-scale-azure-data-factory/";
                        break;
                    }
                    case "azure-databricks": {
                        this.pageData = "azure-databricks";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Azure - Explore Databricks",
                            },
                        ];
                        this.courseLink =
                            "https://docs.microsoft.com/en-us/learn/modules/explore-azure-databricks/";
                        break;
                    }

                    case "Kepler-data-eng": {
                        this.pageData = "Kepler-data-eng";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Kepler for Data Engineers",
                            },
                        ];
                        this.courseLink = "";
                        break;
                    }
                    case "university-mdp": {
                        this.pageData = "university-mdp";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "MDP - Introduction",
                            },
                        ];
                        this.courseLink =
                            "https://ishareteam6.na.xom.com/sites/NextField/MDP/_layouts/15/start.aspx#/#InplviewHashd8f5c0b2-9132-4540-848b-93d15f26cd5f=";
                        break;
                    }
                    case "university-uda": {
                        this.pageData = "university-uda";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "UDA - Introduction",
                            },
                        ];
                        this.courseLink =
                            "https://uda-data-platform-rtd.uda.xom.cloud/index.html";
                        break;
                    }
                    case "Kepler-data-ana": {
                        this.pageData = "Kepler-data-ana";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Kepler for Data Analysts",
                            },
                        ];
                        this.courseLink = "";
                        break;
                    }
                    case "airflow-training": {
                        this.pageData = "airflow-training";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Airflow Training",
                            },
                        ];
                        this.courseLink =
                            "https://airflow.apache.org/docs/apache-airflow/stable/tutorial.html";
                        break;
                    }
                    case "openshift-basics": {
                        this.pageData = "openshift-basics";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Azure Red Hat OpenShift Basics",
                            },
                        ];
                        this.courseLink =
                            "https://www.redhat.com/rhdc/managed-files/pa-getting-started-azure-openshift-ebook-f20686-201911-en_0.pdf";
                        break;
                    }
                    case "openshift-foundation": {
                        this.pageData = "openshift-foundation";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Foundations of OpenShift",
                            },
                        ];
                        this.courseLink =
                            "https://developers.redhat.com/learn/openshift/openshift-pipelines";
                        break;
                    }
                    case "university-kepler": {
                        this.pageData = "university-kepler";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Kepler",
                            },
                        ];
                        this.courseLink =
                            "https://kepler-docs.apps.dp01.exxonmobil.com/";
                        break;
                    }
                    case "university-snowflake": {
                        this.pageData = "university-snowflake";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Snowflake",
                            },
                        ];
                        this.courseLink =
                            "https://quickstarts.snowflake.com/guide/getting_started_with_snowflake/index.html#0";
                        break;
                    }
                    case "snowflake-datavisualization": {
                        this.pageData = "snowflake-datavisualization";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Snowflake - Data Visualization",
                            },
                        ];
                        this.courseLink =
                            "https://kepler-docs.apps.dp01.exxonmobil.com/deeper_dive/#data-visualization";
                        break;
                    }
                    case "snowflake-datawarehousing": {
                        this.pageData = "snowflake-datawarehousing";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Snowflake - Data WareHousing",
                            },
                        ];
                        this.courseLink =
                            "https://learn.snowflake.com/courses/course-v1:snowflake+ESS_DWW_101+2021/about";
                        break;
                    }
                    case "university-kepler-deeper": {
                        this.pageData = "university-kepler-deeper";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "Deeper Dive - Kepler",
                            },
                        ];
                        this.courseLink =
                            "https://kepler-docs.apps.dp01.exxonmobil.com/deeper_dive/";
                        break;
                    }
                    case "default": {
                        this.pageData = "University";
                        this.pageTitleArea = [
                            {
                                title: "University",
                                subTitle: "",
                            },
                        ];
                        break;
                    }
                }
            });

        this.titleService.setTitle("University");
    }

    pageTitleArea: pageTitle[] = [
        {
            title: "University",
            subTitle: "Getting Started",
        },
    ];
}
class pageTitle {
    title: string;
    subTitle: string;
}
